// eslint-disable-next-line import/prefer-default-export
export const getUi = (state) => state.ui;
export const getProducts = (state) => state.products;
export const getRentingCart = (state) => state.rentingCart;
export const getFeedback = (state) => state.feedback;
export const getMarketing = (state) => state.marketing;

// Generics
export const getLoadingState = (state) => state.loadingState;
